import PropTypes from 'prop-types';
import { Button } from 'antd';
import { useState } from 'react';
import './ButtonWithHover.scss';

const ButtonWithHover = ({ normalImage, hoverImage, onClick }) => {
  const [currentImage, setCurrentImage] = useState(normalImage);

  return (
    <Button
      onClick={onClick}
      className="btnWithHover"
      onMouseEnter={() => setCurrentImage(hoverImage)}
      onMouseLeave={() => setCurrentImage(normalImage)}>
      <img src={currentImage} alt="Imagen" />
    </Button>
  );
};

ButtonWithHover.propTypes = {
  normalImage: PropTypes.string.isRequired,
  hoverImage: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};

export default ButtonWithHover;
